import { Grid, Typography } from '@material-ui/core';
import { ExpectedClosingDate } from './expectedClosingDate';
import { ExpectedClosingDateStore } from '../../../stores/documentForms/expectedClosingDateStore';
import { ReasonForAdjournment } from './reasonForAdjournment';
import { ClosingDead } from './closingDead';
import { useEffect } from 'react';
import { observer } from 'mobx-react';

export type ClosingDateContainerProps = {
  store: ExpectedClosingDateStore;
};

export const ClosingDateContainer = observer(
  (props: ClosingDateContainerProps) => {
    const { store } = props;

    useEffect(() => {
      (async () => {
        await store.getLoanClosingAdjournmentData();
        store.initialize();
      })();
      return () => store.disposeDateWatcher();
    }, [store, store.loanStore.loanDetails.loanId]);

    return (
      <Grid container spacing={4}>
        <Grid item md={12}>
          <Typography>
            This will generate the official numbers for the Funding Template and will schedule the loan for closing.
          </Typography>
        </Grid>
        <Grid item md={12}>
          <ExpectedClosingDate store={store} />
        </Grid>
        {/* {store.showClosingDead && (
          <Grid item md={12}>
            <ClosingDead store={store} />
          </Grid>
        )} */}
        {(store.showReasonForAdjournment || (store.showClosingDead && store.form.fields.closingDead.value === false)) && (
          <Grid item md={12}>
            <ReasonForAdjournment store={store} />
          </Grid>
        )}
      </Grid>
    );
  }
);
